// @flow

import React from 'react';

import { ModalManager } from 'react-dynamic-modal';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

import Tbutton from './Tbutton';
import NotificationModal from './NotificationModal';

import t from '../trans';

import SoftwareUpdateStore from "../stores/SoftwareUpdateStore";
import SoftwareUpdateActions from "../actions/SoftwareUpdateActions";
import NotificationActions from "../actions/NotificationActions";
import _ from "underscore";
import Tfile from "./Tfile";
import rootStore from "../stores";

class SoftwareUpdate extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			file: null,
			fileName: null,
			update: SoftwareUpdateStore.getState()
		};

		this.onChange = this.onChange.bind(this);
		this.onClickUpdate = this.onClickUpdate.bind(this);
		this.onClickRestore = this.onClickRestore.bind(this);
		this.onClickRestart = this.onClickRestart.bind(this);
	}

	componentDidMount() {
		SoftwareUpdateStore.listen(this.onChange);
		SoftwareUpdateActions.fetchSoftwareInfo.defer(rootStore.sessionStore.getUsername(), rootStore.sessionStore.getPassword());
	}

	componentWillUnmount() {
		SoftwareUpdateStore.unlisten(this.onChange);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.update.state === "PROCESSING" && this.state.update.state !== "PROCESSING") {
			// Configuration loading or saving finished
			// Check if authentication is required:
		}
	}

	onChange(state) {
		this.setState({
			update: _.clone(state)
		});
	}

	onClickSelectFile(fileData, fileName) {
		this.setState({file: btoa(fileData), fileName: fileName});
	}

	onClickUpdate() {
		if (this.state.file == null) {
			NotificationActions.error.defer(t("Update file not selected"));
		} else {
			this.askConfirmation(t("Update software")+"?", function () {
				SoftwareUpdateActions.update(this.state.file, rootStore.sessionStore.getUsername(), rootStore.sessionStore.getPassword());
			}.bind(this));
		}
	}

	onClickRestore() {
		this.askConfirmation(t("Restore old software version")+"?", function () {
			SoftwareUpdateActions.restore(rootStore.sessionStore.getUsername(), rootStore.sessionStore.getPassword());
		}.bind(this));
	}

	onClickRestart() {
		window.location.reload(true);
	}

	askConfirmation(message, func) {
        ModalManager.open(<NotificationModal title={t("Confirmation")} onClickOk={function() {
            func();
            ModalManager.close();
        }} okText={t('OK')} cancelText={t('Cancel')}>{message}</NotificationModal>);
    }

    renderCurrentSoftware() {
		return (
			<div className="panel panel-default">
				<div className="panel-heading">
					<h3 className="panel-title">Current software version</h3>
				</div>
				<div className="panel-body">
					<form className="form-horizontal">
						<div  className="form-group">
							<label htmlFor="version-info" className="col-sm-2 control-label">{t("Version")+":"}</label>
							<div className="col-sm-10">
								{this.state.update.firmwareInfo.firmwareVersion || ""}
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

    renderUpdateSoftware() {
		return (
			<div className="panel panel-default">
				<div className="panel-heading">
					<h3 className="panel-title">Update software</h3>
				</div>
				<div className="panel-body">
					<form className="form-horizontal">
						<div  className="form-group">
							<label htmlFor="file-input" className="col-sm-2 control-label">{t("Software update file")+":"}</label>
							<div className="col-sm-10">
								<Tfile button={true} width='100px' as='binary' accept=".zip" onClick={(param, fileData, fileName) => this.onClickSelectFile(fileData, fileName)}>{t("Select file")}</Tfile>
							</div>
						</div>
						<div className="form-group">
							<div className="col-sm-2"/>
							<div className="col-sm-10">
								<Tbutton type="button" className="btn btn-primary" onClick={this.onClickUpdate}>Update software</Tbutton>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

    renderRestoreSoftware() {
		return (
			<div className="panel panel-default">
				<div className="panel-heading">
					<h3 className="panel-title">Restore software</h3>
				</div>
				<div className="panel-body">
					<form className="form-horizontal">
						<div  className="form-group">
							<label htmlFor="file-input" className="col-sm-2 control-label">{t("Software update file")+":"}</label>
							<div className="col-sm-10">
								<Tfile button={true} width='100px' as='binary' accept=".zip" onClick={(param, fileData, fileName) => this.onClickSelectFile(fileData, fileName)}>{t("Select file")}</Tfile>
							</div>
						</div>
						<div className="form-group">
							<div className="col-sm-2"/>
							<div className="col-sm-10">
								<Tbutton type="button" className="btn btn-primary" onClick={this.onClickRestore}>Restore software to specified version</Tbutton>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

	renderSpinner() {
		return (
			<Loader
				fullPage
				loading
				text={t("Updating software, please wait...")}
			/>
		);
		//return (<div style={{backgroundColor: "#EFEFEF", position: "fixed", width: "100%", height: "100%", zIndex: "1000", top: "0px", left: "0px", opacity: "0.5", filter: "alpha(opacity=50)"}}/>);
	}

	renderUpdateCompleted() {
		return (
			<div className="panel panel-default">
				<div className="panel-heading">
					<h3 className="panel-title">Update software</h3>
				</div>
				<div className="panel-body">
					<p>
						{t("Update successfully completed, click button 'Restart'!")}
					</p>
					<form className="form-horizontal">
						<div className="form-group">
							<div className="col-sm-2"/>
							<div className="col-sm-10">
								<Tbutton type="button" className="btn btn-primary" onClick={this.onClickRestart}>Restart</Tbutton>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

	renderContent() {
		if (!this.state.update.auth) return null;

		let content = [];
		if (this.state.update.action == "update" && this.state.update.state == "OK") {
			content = [this.renderUpdateCompleted()];
		} else {
			content = [this.renderCurrentSoftware(), this.renderUpdateSoftware()];
			if (this.state.update.action == "update" && this.state.update.state == "PROCESSING") {
				content.push(this.renderSpinner());
			}
		}
		return content;
	}

	render() {
		return (
			<div className="container-fluid">
				{this.renderContent()}
			</div>
        );
	}
}

export default SoftwareUpdate;
